#import "../../fragments/UserFragment.graphql"
#import "../../fragments/BBcodeFragment.graphql"

mutation EditBrickfilmMutation($input: EditBrickfilmInput!) {
  editBrickfilm(input: $input) {
    brickfilm {
      id
      title
      description
      type
      language
      slug
      runtime
      containsExplicitContent
      picture
      isArchived
      picturePath
      isAbandoned
      containsExplicitContent
      allowedToReuse
      isUnavailable
      videoLinks: links(isEditable: true, kind: FILM) {
        id
        link
        type
        reference
      }
      teaserLinks: links(isEditable: true, kind: TEASER) {
        id
        link
        type
        reference
      }

      castMembers {
        id
        role
        additionnalInformation
        memberName
        member {
          ...UserFragment
        }
      }
      productionNotes {
        id
        createdAt
        content {
          ...BBcodeFragment
        }
      }
      makingOf {
        ...BBcodeFragment
      }
      allowedActions
    }
  }
}